import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import {
  Form,
  useActionData,
  useNavigate,
  useNavigation
} from "react-router-dom";

const BidderDialog = ({ isEditing = false, bidder = {} }) => {
  const form = useActionData();
  const navigate = useNavigate();
  const navigation = useNavigation();

  return (
    <Dialog
      onClose={() => navigate("/programmatic_supply/bidders")}
      maxWidth="xs"
      PaperProps={{ sx: { borderRadius: 5 } }}
      open
    >
      <Form method="post">
        <DialogTitle variant="subtitle1">
          {isEditing ? "Edit Bidder" : "Add New Bidder"}
        </DialogTitle>
        <DialogContent>
          {form?.success && (
            <Alert severity="success" sx={{ mb: 1 }}>
              Changes Saved.
            </Alert>
          )}
          <Grid container>
            <Grid item xs={12} sx={{ pt: 1 }}>
              <TextField
                error={form?.errors?.hasOwnProperty("name")}
                fullWidth
                helperText={form?.errors?.["name"]}
                label="Bidder Name"
                name="name"
                defaultValue={bidder.name}
                required
              />
            </Grid>
            <Grid item xs={12} sx={{ pt: 4.5 }}>
              <TextField
                error={form?.errors?.hasOwnProperty("url")}
                fullWidth
                helperText={form?.errors?.["url"]}
                label="Endpoint URL"
                name="url"
                defaultValue={bidder.url}
                required
              />
            </Grid>
            <Grid item xs={12} sx={{ pt: 4.5 }}>
              <TextField
                select
                fullWidth
                label="Status"
                name="active"
                defaultValue={bidder.active?.toString() ?? "true"}
              >
                <MenuItem key="active" value="true">Active</MenuItem>
                <MenuItem key="inactive" value="false">Inactive</MenuItem>
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 4 }}>
          <LoadingButton
            type="submit"
            loading={navigation.state === "submitting"}
            variant="contained"
          >
            Save
          </LoadingButton>
          <Button
            disabled={navigation.state === "submitting"}
            onClick={() => navigate("/programmatic_supply/bidders")}
            variant="outlined"
          >
            Cancel
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  );
};

export default BidderDialog;
